var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maintenanceDetail.message_show)?_c('div',{staticClass:"maintenance-message"},[_vm._v(" "+_vm._s(_vm.maintenanceDetail.message_text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }